import React from 'react'
import { Box, Text } from '@mantine/core'

const SampleWatermark: React.FC = () => {
  const watermarkText = '示例数据 仅供演示'
  const rows = 8
  const cols = 6

  return (
    <Box
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        pointerEvents: 'none',
        zIndex: 1,
        overflow: 'hidden',
      }}
    >
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <Box
          key={rowIndex}
          style={{
            display: 'flex',
            justifyContent: 'space-around',
            marginTop: rowIndex === 0 ? '10%' : '8%',
          }}
        >
          {Array.from({ length: cols }).map((_, colIndex) => (
            <Text
              key={colIndex}
              size="xl"
              fw={500}
              style={{
                color: '#666666',
                opacity: 0.08,
                transform: 'rotate(-45deg)',
                userSelect: 'none',
                whiteSpace: 'nowrap',
              }}
            >
              {watermarkText}
            </Text>
          ))}
        </Box>
      ))}
    </Box>
  )
}

export default SampleWatermark
